module.exports = __webpack_public_path__ + "media/images/sp/specials/common/store_nagoya_ekimae-6cd67c215afc0e793a77ff1efabfbbdc.jpg";